import { compose, map, prop, reduce, values } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getContactOrders = compose(prop('contactOrders'), getRoot);
export const getContactOrderById = (state, id) => getContactOrders(state)[id];

export const getContactOrdersList = createSelector(getContactOrders, values);

export const getContactOrdersIds = createSelector(
	getContactOrdersList,
	map((o) => o.id),
);

export const getTotalOrderNumber = createSelector(
	getContactOrdersList,
	reduce((acc, contactOrder) => {
		return acc + (contactOrder.orderedLeads ? Number(contactOrder.orderedLeads) : 0);
	}, 0),
);
